export const RE_DIGIT = /\d+$/
export const RE_NON_DIGIT = /\D/g
